'use strict';

var tracking = require('../modules/utils/tracking.utils');
var TRACK_EVENTS = {
    'error_management_sessionExpired': {
        'load': {
            'action': 'back_end_errors',
            'label': 'session_expiring_expired',
            'analytics': false,
        },
        'click': {
            'action': 'back_end_errors',
            'label': 'session_expiring_new_search',
        },
        'clickSameSearch': {
            'action': 'back_end_errors',
            'label': 'session_expiring_same_search',
        },
        'clickDialogPhone': {
            'action': 'back_end_errors',
            'label': 'session_expiring_call_us',
        },
    },
    'error_management_packageNotAvailable': {
        'load': {
            'action': Odigeo._.template('results_list_<%= obj %>'),
            'label': Odigeo._.template('shared_dynpack_no_results_found_<%= obj %>'),
        },
        'click': {
            'action': Odigeo._.template('results_list_<%= obj %>'),
            'label': Odigeo._.template('undo_shared_dynpack_no_results_found_<%= obj %>'),
        },
        'clickSameSearch': {
            'action': Odigeo._.template('results_list_<%= obj %>'),
            'label': Odigeo._.template('relaunch_shared_dynpack_no_results_found_<%= obj %>'),
        },
    },
    'error_management_noResults': {
        'load': {
            'action': Odigeo._.template('results_list_<%= obj %>'),
            'label': Odigeo._.template('searching_dynpack_no_results_found_<%= obj %>'),
        },
        'click': {
            'action': Odigeo._.template('results_list_<%= obj %>'),
            'label': Odigeo._.template('undo_searching_dynpack_no_results_found_<%= obj %>'),
        },
    },
    'compressed_header': {
        'click': {
            'action': 'searcher_dynpack',
            'label': 'click_change_search',
        },
    },
    'dpresults_accommodation_details': {
        'onLoadRoomList': {
            'action': 'rooms_list',
            'label': onRoomsLoaded,
        },
        'onLoadRoomCards': {
            'action': 'room_selection_list',
            'label': onRoomsLoaded,
        },
        'onSelectRoom': {
            'action': 'room_selection_list',
            'label': Odigeo._.template('room_selected_<%= obj %>'),
        },
    },
    'stepper': {
        'click': {
            'action': 'header',
            'label': Odigeo._.template('click_<%= obj %>'),
        },
    },
    'filter_flights': {
        'click': {
            'action': 'results_filters',
            'label': 'open_filters_float',
        },
    },
    'filter_hotels': {
        'click': {
            'action': 'results_filters_hotels',
            'label': 'open_filters',
        },
    },
    'most_popular': {
        'click': {
            'action': 'results_list_hotels',
            'label': 'sort_open',
        },
    },
    'map': {
        'click': {
            'action': 'results_list_hotels',
            'label': 'map_open_all_hotels',
        },
    },
    'modify_links': {
        'click': {
            'action': 'trip_information',
            'label': Odigeo._.template('<%= obj %>'),
        },
    },
    'dp_price_summary': {
        'click': {
            'action': 'discount',
            'label': 'click_flighthotel_discount_price-summary',
        },
    },
    'accommodation_menu_bar': {
        'click': {
            'action': 'rooms_menu',
            'label': Odigeo._.template('menu_option_<%= obj %>'),
        },
    },
};

function onRoomsLoaded(data) {
    var roomsProvider = Odigeo._.size(data.listRoomDeals);
    var roomsLoaded = Odigeo._.size(data.reductionRoomDeals);
    var hasReductionApplied = Number(!Odigeo._.isEqual(roomsProvider, roomsLoaded)) ? 'yes' : 'no';

    return [
        'room_showed',
        'reduc:' + hasReductionApplied,
        'num:' + roomsProvider + '-' + roomsLoaded,
    ].join('_');
}

module.exports = function(product) {
    var customTracking = TRACK_EVENTS[product];

    function getTrackingData(type, paramLabel, paramAction) {
        var typeInfo = customTracking[type];

        return {
            'action': Odigeo._.isFunction(typeInfo.action) ? typeInfo.action(paramAction) : typeInfo.action,
            'label': Odigeo._.isFunction(typeInfo.label) ? typeInfo.label(paramLabel) : typeInfo.label,
            'analytics': typeInfo.analytics,
        };
    }

    function trackEvent(type, paramLabel, paramAction) {
        var trackingData = getTrackingData(type, paramLabel, paramAction);

        tracking.trackEvent(trackingData.action, trackingData.label, null, false, trackingData.analytics);
    }

    return Odigeo._.mapValues(customTracking, function(options, type) {
        return Odigeo._.partial(trackEvent, type);
    });
};
